import React from 'react';
import ReactDOM from "react-dom";
import { Timeline } from 'react-twitter-widgets';

const TwitterPacific = (props) => {
    if (props.source !== undefined) {
        return (
            <Timeline 
              dataSource={props.source.dataSource}
              options={props.source.options}
            />
        )
    }
    else {
        return <p>Loading...</p>
    }
    
}

ReactDOM.render((<TwitterPacific />), document.getElementById('root'));
export default TwitterPacific;


// WEBPACK FOOTER //
// ./src/components/TwitterPacific.js